export const findProductById = (productId, products) =>
	products.find((product) => product._id === productId);
